<template>
  <div class="card editable-card">
      <div style="display: flex;">
        <div class="links-body">
          <div class="statBlock">
            <div class="card-header" v-if="$slots.header">
              <slot name="header"></slot>
            </div>
            <div class="card-body">
              <div><textarea class="notes-box" placeholder="Enter your notes about this company here..." v-model="localText" v-on:change="valueChanged()"></textarea></div>
              <div v-if="isModal" class="actionbuttons">
                <button @click="cancel" class="btn btn-info btn-fill btn-wd">Cancel</button>
                <button @click="save" class="btn btn-info btn-fill btn-wd">Save</button>
              </div>
            </div>
            <div class="card-footer" v-if="$slots.footer">
              <slot name="footer"></slot>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>
<script>
  import Card from '../Card.vue'

  export default {
    name: 'edit-text-area-card',
    components: {
      Card
    },
    props: ['text', 'context', 'isModal'],
    data () {
      return {
        localText: _.cloneDeep(this.text)
      }
    },
    methods: {
      cancel () {
        this.$emit('edit-text-area-card-close', this.context, {confirm: false})
      },
      save () {
        this.$emit('edit-text-area-card-close', this.context, {confirm: true, data: this.localText})
      },
      valueChanged() {
        this.$emit('card-onchange')
      }
    },
    watch: {
      text(newText) {
        this.localText = _.cloneDeep(newText)
      },
      localText(newText) {
        if (!this.isModal) this.$emit('text-changed', this.context, {text: newText})
      }
    }
  }
</script>
<style>
.editable-card {
  height: calc(100% - 30px);
}

/*.edit-button {
    display: block !important;
    width: calc(100% - 10px);
    text-align: center;
    border-top: 1px solid #dfdfdf;
    font-size: 0.8em;
    margin-bottom: 5px;
    margin-left: 5px;
    margin-top: 30px;
}*/

.links-body {
    width: 100% !important;
}
</style>